module.exports = __webpack_public_path__ + "img/logo-payroll-tax.d44c3ae8.png";